import { render, staticRenderFns } from "./BikeDialogTires.vue?vue&type=template&id=10f93fdc&"
import script from "./BikeDialogTires.vue?vue&type=script&lang=js&"
export * from "./BikeDialogTires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports